import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'accountable'

export default function Accountablepage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'beginner' ||
    value === 'novice' ||
    value === 'intermediate' ||
    value === 'advanced'
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How do you like to stay accountable?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.accountable.heading')}
      buttons={[
        {
          text: t('pages.onboarding.accountable.options.soloMissions'),
          value: 'soloMissions',
        },
        {
          text: t('pages.onboarding.accountable.options.groupRuns'),
          value: 'groupRuns',
        },
        {
          text: t('pages.onboarding.accountable.options.shareMedia'),
          value: 'shareMedia',
        },
        {
          text: t('pages.onboarding.accountable.options.hireCoach'),
          value: 'hireCoach',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
